import Vue from 'vue';
import VueRouter from 'vue-router';

import DashView from '@/layouts/Dash.vue';
import AuthView from '@/layouts/Auth.vue';
import MeetingView from '@/layouts/Meeting.vue';

// import Authenticator from '@/views/Authenticator.vue';
import Dashboard from '@/views/Dashboard.vue';
import Users from '@/views/users/Index.vue';
import Teams from '@/views/teams/Index.vue';
import Companies from '@/views/companies/Index.vue';
import Profile from '@/views/Profile.vue';
import Meetings from '@/views/meetings/Index.vue';
import Rooms from '@/views/rooms/Index.vue';
import Sync from '@/views/Sync.vue';
import SignIn from '@/views/auth/SignIn.vue';
import SignUp from '@/views/auth/SignUp.vue';
import ForgotPassword from '@/views/auth/ForgotPassword.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';
import ConfirmCode from '@/views/auth/ConfirmCode.vue';

import authGuard from './authGuard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/auth',
    name: 'auth-view',
    component: AuthView,
    children: [
      {
        path: '/sign-in',
        alias: '/auth',
        name: 'SignIn',
        component: SignIn,
      }, {
        path: '/sign-up',
        name: 'SignUp',
        component: SignUp,
      }, {
        path: '/confirm',
        name: 'ConfirmCode',
        component: ConfirmCode,
      }, {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
      }, {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPassword,
      },
    ],
  }, {
    path: '/meeting',
    name: 'MeetingView',
    component: MeetingView,
    children: [
      {
        path: '/meeting/:title/:meetingId',
        name: 'Rooms',
        component: Rooms,
        meta: { title: 'Rooms' },
      },
    ],
  }, {
    path: '/',
    name: 'DashView',
    component: DashView,
    children: [
      {
        path: '/sync',
        name: 'Sync',
        component: Sync,
        meta: { title: 'Syncing...', requiresAuth: true },
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: 'Dashboard', requiresAuth: true },
        // If route level code-splitting needed?
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      }, {
        path: '/meetings',
        alias: '/',
        name: 'Meetings',
        component: Meetings,
        meta: { title: 'Meetings', requiresAuth: true },
      }, {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: { title: 'Users', requiresAuth: true },
      }, {
        path: '/teams',
        name: 'Teams',
        component: Teams,
        meta: { title: 'Teams', requiresAuth: true },
      }, {
        path: '/companies',
        name: 'Companies',
        component: Companies,
        meta: { title: 'Companies', requiresAuth: true },
      }, {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { title: 'Profile', requiresAuth: true },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeResolve(authGuard);

export default router;
